import React, { useEffect, useState } from "react";
import {
    Card, Col, Row, Avatar, Typography, Divider, Grid, List,
    Button, Checkbox, Table
} from "antd";
import { Line } from "@ant-design/charts";
import { UserOutlined } from "@ant-design/icons";
import { User } from "../../Model/dbo/User";
import Cookies from "universal-cookie";
import { BaseApi } from "../../RestAPI/dbo/BaseUrl";
import InfiniteScroll from "react-infinite-scroll-component";
import { Index } from "../../Model/dbo/Index";
import { GetUnitIndex, GetUnitIndexValue } from "../../RestAPI/dbo/IndexApi";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { AddFcm } from "../../RestAPI/dbo/Loginapi";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const Home: React.FC = () => {
    const [user, setUser] = useState<User>();
    const [indexes, setIndexes] = useState<Index[]>([]);
    const [isFullScreen, setIsFullScreen] = useState<string | null>(null);
    const [UnitIndexLineChart, setUnitIndexLineChart] = useState({});
    const [indexValue, setIndexValue] = useState<Array<any>>([]);
    const [indexValueFilter, setIndexValueFilter] = useState<Array<any>>([]);
    const [notiPer, SetNotiPer] = useState(true);
    const [showTable, setShowTable] = useState(false); // 👈 نمایش جدول یا نمودار
    const [showPersonChartTable, setShowPersonChartTable] = useState(false);

    const [screen, setScreen] = useState((window.innerWidth > 992) ? 495 : 250);
    const screens = useBreakpoint();
    const navigate = useNavigate();

    async function FetchUnitIndexValue() {
        const res = await GetUnitIndexValue();
        setIndexValue(res);
        setIndexValueFilter(res);
        SetLineConfig(res);
        requestPermission();
    }

    const requestPermission = () => {
        if (!("Notification" in window)) {
            SetNotiPer(false);
            return;
        }

        Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
                AddFcm();
                SetNotiPer(false);
            }
        });
    };

    function SetLineConfig(res: any[]) {
        setUnitIndexLineChart({
            data: res,
            xField: "Month",
            yField: "Score",
            point: {
                shapeField: "square",
                sizeField: 2,
            },
            colorField: "IndexDesc",
            style: {
                lineWidth: 1,
            },
            height: 450,
            smooth: true,
            scrollbar: {
                x: {
                    ratio: 1,
                    value: 1,
                },
            },
            legend: {
                color: {
                    layout: {
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        flexDirection: 'column',
                    },
                    cols: 3,
                    maxRows: 3
                },
            },
        });
    }

    async function FetchUnitIndex() {
        const res = await GetUnitIndex();
        setIndexes(res);
    }

    useEffect(() => {
        setUser(new Cookies().get("user"));
        FetchUnitIndex();
        FetchUnitIndexValue();
    }, []);

    const PersonelScoreLineChart = {
        data: {
            type: "fetch",
            value: BaseApi + "hr/GetPersonScore?token=" + new Cookies().get("user").Token + ".json",
        },
        xField: "Month",
        yField: "Value",
        point: {
            shapeField: "square",
            sizeField: 2,
        },
        colorField: "Category",
        style: {
            lineWidth: 1,
        },
        height: 250,
        smooth: true,
        legend: {
            color: {
                layout: {
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    flexDirection: 'row',
                },
                cols: 4,
                maxRows: 3
            },
        },
    };

    const handleFullscreenToggle = (chartId: string) => {
        setIsFullScreen(prev => (prev === chartId ? null : chartId));
    };

    async function ChangeItems(e: CheckboxChangeEvent) {
        if (!e.target.checked) {
            const res = indexValueFilter.filter(p => p.IndexCode !== e.target.id);
            const final = res.sort((a, b) => a.Year - b.Year || a.Duration - b.Duration);
            setIndexValueFilter(final);
            SetLineConfig(final);
        } else {
            const addedItems = indexValue.filter(p => p.IndexCode === e.target.id);
            const merged = [...indexValueFilter, ...addedItems];
            const final = merged.sort((a, b) => a.Year - b.Year || a.Duration - b.Duration);
            setIndexValueFilter(final);
            SetLineConfig(final);
        }
    }

    const NavigateToServey = () => {
        navigate("/Survey");
    };

    return (
        <div style={{ padding: screens.xs ? 10 : 20 }}>
            {notiPer && (
                <Row>
                    <Col lg={24}>
                        <Card style={{ marginBottom: 10 }}>
                            <Button onClick={requestPermission}>لطفا اجازه ی ارسال اعلان را بدهید</Button>
                        </Card>
                    </Col>
                </Row>
            )}

            {!user?.hasServey && (
                <Row>
                    <Col lg={24}>
                        <Card style={{ marginBottom: 10 }}>
                            <h3>همکار گرامی تکمیل نظر سنجی به بهود فعالیت های واحد منابع انسانی در جهت رضایت شما کمک میکند</h3>
                            <Button onClick={NavigateToServey}>شرکت در نظرسنجی </Button>
                        </Card>
                    </Col>
                </Row>
            )}

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} lg={6}>
                    <Card style={{ textAlign: "center", height: 350 }}>
                        <div style={{ marginTop: 10 }}>
                            <Avatar size={screens.xs ? 60 : 80} icon={<UserOutlined />} />
                            <Title level={4}>{user?.Name}</Title>
                            <Divider />
                            <Title level={5}>شغل: {user?.Job}</Title>
                            <Title level={5}>کد پرسنلی: {user?.PersonelNo}</Title>
                            <Title level={5}>کد بیمه: {user?.InsuranceNo}</Title>
                            <Title level={5}>باقی مانده مرخصی
                                {(user?.uesedmorakhasi || '').replace(/\d+/g, '').replace('.', '').replace('ماه', '')}: {user?.remainingmorakhasi != null
                                    ? Number(user.remainingmorakhasi).toFixed(2)
                                    : ''}
                            </Title>
                        </div>
                    </Card>
                </Col>

                <Col xs={24} sm={24} lg={18}>
                    <Card
                        title="ارزیابی ماهانه"
                        style={{
                            height: isFullScreen === "personelChart" ? "100vh" : 350,
                            width: isFullScreen === "personelChart" ? "100vw" : "auto",
                            zIndex: isFullScreen === "personelChart" ? 999 : "initial",
                            position: isFullScreen === "personelChart" ? "fixed" : "relative",
                            top: 0,
                            left: 0,
                            display: "flex",
                            flexDirection: "column",
                            direction: "ltr",
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                            <Button onClick={() => handleFullscreenToggle("personelChart")}>
                                {isFullScreen === "personelChart" ? "خروج از حالت تمام صفحه" : "تمام صفحه"}
                            </Button>

                            {/* <Button onClick={() => setShowPersonChartTable(prev => !prev)}>
        {showPersonChartTable ? "مشاهده نمودار" : "مشاهده به صورت جدول"}
      </Button> */}

                        </div>

                        <div style={{ flex: 1 }}>
                            {showPersonChartTable ? (
                                <></>
                                // <Table
                                //   dataSource={[] /* 👈 اگر داده‌ها در state نیستند، آن‌ها را باید جداگانه fetch کنید */}
                                //   columns={[
                                //     { title: "دسته", dataIndex: "Category", key: "Category" },
                                //     { title: "سال", dataIndex: "Year", key: "Year" },
                                //     { title: "ماه", dataIndex: "Month", key: "Month" },
                                //     { title: "مقدار", dataIndex: "Value", key: "Value" },
                                //   ]}
                                // //   rowKey={(record) => `${record.Category}-${record.Year}-${record.Month}`}
                                //   pagination={{ pageSize: 10 }}
                                // />
                            ) : (
                                <Line {...PersonelScoreLineChart} style={{ height: "100%", width: "100%" }} />
                            )}
                        </div>
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                <Col xs={24} sm={24} lg={20}>
                    <Card
                        title={"عملکرد واحد " + user?.Unit}
                        style={{
                            height: isFullScreen === "unitChart" ? "100vh" : 600,
                            width: isFullScreen === "unitChart" ? "100vw" : "auto",
                            zIndex: isFullScreen === "unitChart" ? 999 : "initial",
                            position: isFullScreen === "unitChart" ? "fixed" : "relative",
                            top: 0,
                            left: 0,
                            display: "flex",
                            flexDirection: "column",
                            direction: "ltr"
                        }}
                    >
                        <Button onClick={() => handleFullscreenToggle("unitChart")} style={{ alignSelf: "flex-end" }}>
                            {isFullScreen === "unitChart" ? "خروج از حالت تمام صفحه" : "تمام صفحه"}
                        </Button>

                        <Button onClick={() => setShowTable(prev => !prev)} style={{ alignSelf: "flex-start", marginBottom: 8 }}>
                            {showTable ? "مشاهده نمودار" : "مشاهده به صورت جدول"}
                        </Button>

                        <div style={{ flex: 1, overflowX: "auto" }}>
                            {showTable ? (
                                <Table
                                    dataSource={indexValueFilter}
                                    columns={[
                                        { title: "شاخص", dataIndex: "IndexDesc", key: "IndexDesc" },
                                        { title: "سال", dataIndex: "Year", key: "Year" },
                                        { title: "ماه", dataIndex: "Month", key: "Month" },
                                        { title: "نمره", dataIndex: "Score", key: "Score" },
                                    ]}
                                    rowKey={(record) => `${record.IndexCode}-${record.Year}-${record.Month}`}
                                    pagination={{ pageSize: 10 }}
                                />
                            ) : (
                                <Line {...UnitIndexLineChart} style={{ width: "80%" }} />
                            )}
                        </div>
                    </Card>
                </Col>

                <Col xs={24} sm={24} lg={4}>
                    <Card title="شاخص ها" style={{ direction: "ltr" }}>
                        <div style={{ backgroundColor: "white", borderRadius: 8, direction: "ltr" }}>
                            <InfiniteScroll
                                style={{ height: screen }}
                                dataLength={5}
                                next={() => { }}
                                hasMore={false}
                                loader={<></>}
                                endMessage={<></>}
                                scrollableTarget="scrollableDiv"
                            >
                                <List
                                    dataSource={indexes}
                                    renderItem={item => (
                                        <List.Item key={item.IndexCode}>
                                            <div style={{ direction: "rtl", textAlign: "justify", padding: 4 }}>
                                                <Checkbox
                                                    id={"" + item.IndexCode}
                                                    defaultChecked={true}
                                                    style={{ margin: 3 }}
                                                    onChange={ChangeItems}
                                                >
                                                    {item.Name}
                                                </Checkbox>
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            </InfiniteScroll>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Home;
